export default __webpack_public_path__ + "static/media/step_2.95b2ca78.jpeg";